import { render } from "./RoomPage.vue?vue&type=template&id=1a27a86a&scoped=true"
import script from "./RoomPage.vue?vue&type=script&lang=js"
export * from "./RoomPage.vue?vue&type=script&lang=js"

import "./RoomPage.vue?vue&type=style&index=0&id=1a27a86a&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-1a27a86a"

export default script